import { bbox } from '@turf/turf';
import { useSelector } from 'react-redux';
import { Icon } from '@nazka/nazka.mapframe.components';
import { useCurrentJobDestination } from '@App/components/SharedCompanyInfo/NearbyCompanySection/nearby-company-section.utils';
import { useVacancy, useRoute } from '@services/query.service';
import {
  formatDistance, formatTime, formatHoursMinutes, generateUniqueId, 
  getTransportMode, shouldUseDateForTransportType, 
} from '@services/utils.service';

import { getTransportModeLayout, fitBounds } from '../route-info.utils';

import './route-directions.styl';

function RouteDirections({ map, forPrint }) {
  const homeAddress = useSelector(state => state.map.homeAddress);
  const vdabReferentie = useSelector(state => state.vacancy.vdabReferentie);
  const OIDN = useSelector(state => state.vacancy.OIDN);
  const transportMode = useSelector(state => state.map.transportMode);
  const currentRouteInfoPanelHeight = useSelector(state => state.map.currentRouteInfoPanelHeight);

  const homeAddressCoordinates = { lat: homeAddress?.center[1], lng: homeAddress?.center[0] };
  const transportDateTime = useSelector(state => state.filter.transportDateTime);

  const { data: company } = useVacancy(OIDN);

  const toCoordinates = useCurrentJobDestination(company, vdabReferentie);

  const { data } = useRoute(
    homeAddressCoordinates,
    toCoordinates,
    getTransportMode(transportMode),
    shouldUseDateForTransportType(transportMode) ? transportDateTime : undefined,
  );

  return (
    <div className="route-directions">
      {data?.route?.features && data.route.features.map((feature) => {
        const {
          properties: {
            mode, distance, duration, routeShortName, headsign, tripShortName, from, to,
            routeColor, routeTextColor,
          }, 
          weight_name: weightName, 
          distance: fallbackDistance,
          duration: fallbackDuration,
        } = feature || {};

        const {
          icon, iconSize, name, color, 
        } = getTransportModeLayout(mode, weightName, transportMode);

        return (
          <div 
            className="route-directions__modal"
            key={generateUniqueId()}
            onClick={() => {
              const bounds = bbox(feature?.geometry);
              if (map && bounds) {
                fitBounds(map, bounds, currentRouteInfoPanelHeight, forPrint);
              }
            }}
          >
            <span 
              className="route-directions__modal__color-line"
              style={{ backgroundColor: color }}
            />
            <div className="route-directions__modal__base-info">
              <div className="route-directions__modal__base-info__type">
                <Icon 
                  className="route-directions__modal__base-info__type__icon"
                  icon={icon}
                  size={iconSize ?? '24px'}
                />
                <p className="route-directions__modal__base-info__type__text">
                  {name}
                </p>
              </div>
              <div className="route-directions__modal__base-info__distance">
                {`${formatDistance(distance || fallbackDistance)} / ${formatTime(duration || fallbackDuration)}`}
              </div>
            </div>
            {['RAIL', 'BUS'].includes(mode) && (
              <>
                <div className="route-directions__modal__line-info">
                  {mode === 'RAIL' && (
                    <>
                      <span className="route-directions__modal__line-info__train">
                        {`${routeShortName} ${tripShortName} `}
                      </span>
                      richting
                    </>
                  )}
                  {mode === 'BUS' && (
                    <span 
                      className="route-directions__modal__line-info__bus"
                      style={{ color: `#${routeTextColor}`, backgroundColor: `#${routeColor}`, borderColor: `#${routeTextColor}` }}
                    >
                      {`${routeShortName}`}
                    </span>
                  )}
                  {` ${headsign}`}
                </div>
                <div className="route-directions__modal__stops">
                  <div className="route-directions__modal__stops__start">
                    {`${from?.name}`}
                    <span className="route-directions__modal__stops__start__time">
                      {formatHoursMinutes(from?.departure)}
                    </span>
                  </div>
                  <div className="route-directions__modal__stops__stop">
                    {`${to?.name}`}
                    <span className="route-directions__modal__stops__stop__time">
                      {formatHoursMinutes(to?.arrival)}
                    </span>
                  </div>
                </div>
              </>
            )}
          </div>
        );
      })}
    </div>
  )
}

export default RouteDirections;